export const UPDATE_DATA = 'UPDATE_DATA'

export const USER_REGISTER = 'USER_REGISTER'
export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const UPDATE_LOGIN = 'UPDATE_LOGIN'
export const USER_RESET_DEFAULTS = 'USER_RESET_DEFAULTS'
export const USER_DATA_UPDATE = 'USER_DATA_UPDATE'

export const FETCHING_FEED_DATA = 'FETCHING_FEED_DATA'
export const FETCHING_USER_DATA = 'FETCHING_USER_DATA'

export const REPLACE_ALL_DEFAULTS = 'REPLACE_ALL_DEFAULTS'

export const BACKGROUNDER_SAVE = 'BACKGROUNDERS_SAVE'
export const BACKGROUNDER_UPDATE = 'BACKGROUNDERS_UPDATE'
export const BACKGROUNDER_DELETE = 'BACKGROUNDERS_DELETE'
export const BACKGROUNDER_UPDATE_DEFAULT_NUMBER =
  'BACKGROUNDERS_UPDATE_DEFAULT_NUMBER'

export const FINISHING_SAVE = 'FINISHINGS_SAVE'
export const FINISHING_UPDATE = 'FINISHINGS_UPDATE'
export const FINISHING_DELETE = 'FINISHINGS_DELETE'
export const FINISHING_UPDATE_DEFAULT_NUMBER =
  'FINISHINGS_UPDATE_DEFAULT_NUMBER'

export const PROJECTION_SAVE = 'PROJECTIONS_SAVE'
export const PROJECTION_UPDATE = 'PROJECTIONS_UPDATE'
export const PROJECTION_DELETE = 'PROJECTIONS_DELETE'
export const PROJECTION_UPDATE_DEFAULT_NUMBER =
  'PROJECTION_UPDATE_DEFAULT_NUMBER'

export const API_OK = 'OK'
export const API_FAIL = 'FAIL'
export const API_MESSAGE = 'MESSAGE'

export const USER_ACCEPTED_TOS = 'USER_ACCEPTED_TOS'
export const USER_CLEAR_DATA = 'USER_CLEAR_DATA'

export const UPDATE_BARLEY_COST = 'UPDATE_BARLEY_COST'



// WEBPACK FOOTER //
// ./src/actionTypes.js